module.exports = __webpack_public_path__ + "img/5.6d9baaa8.png";